exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".billing-table[data-v-541d2dcd] {\n  width: 100%;\n}[dir] .billing-table[data-v-541d2dcd] {\n  padding: 0;\n}\n", ""]);

// exports
